import { useEffect, useState } from 'react';
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

export function PdfPreview({url,onReady}:{url:string;onReady:(ready:boolean)=>void}) {
  const [pages,setPages]=useState<Array<{image:string;text:string}>>([]); const [error,setError]=useState('');
  useEffect(()=>{
    let active=true;let cleanup:(()=>void)|undefined;
    void (async()=>{
      try{
        const pdfjs=await import('pdfjs-dist');
        pdfjs.GlobalWorkerOptions.workerSrc=workerUrl;
        const bytes=new Uint8Array(await (await fetch(url)).arrayBuffer());
        const task=pdfjs.getDocument({data:bytes,isEvalSupported:false,useSystemFonts:true});
        cleanup=()=>{void task.destroy();};
        const pdf=await task.promise;
        if(pdf.numPages>100)throw new Error('This document exceeds the 100-page review limit. Split it before uploading.');
        const rendered:Array<{image:string;text:string}>=[];
        for(let number=1;number<=pdf.numPages;number++){
          if(!active)return;
          const page=await pdf.getPage(number);const base=page.getViewport({scale:1});
          const viewport=page.getViewport({scale:Math.min(1.5,1400/base.width,2000/base.height)});
          const canvas=document.createElement('canvas');canvas.width=Math.ceil(viewport.width);canvas.height=Math.ceil(viewport.height);
          const context=canvas.getContext('2d');if(!context)throw new Error('PDF rendering is unavailable');
          await page.render({canvas,canvasContext:context,viewport}).promise;
          const content=await page.getTextContent();
          rendered.push({image:canvas.toDataURL('image/png'),text:content.items.map((item)=>'str' in item?item.str:'').join(' ')});
          page.cleanup();
        }
        if(active){setPages(rendered);setError('');onReady(true);}
      }catch(reason){if(active){setError((reason as Error).message);onReady(false);}}
    })();
    return()=>{active=false;cleanup?.();};
  },[url,onReady]);
  return <div aria-label="Saved notice PDF pages">{error?<div role="alert" className="alert error">{error}</div>:!pages.length?<p role="status">Rendering the saved PDF…</p>:pages.map((page,index)=><figure key={index} style={{margin:'16px 0'}}><figcaption>Page {index+1} of {pages.length}</figcaption><img src={page.image} alt={`Notice page ${index+1}: ${page.text}`} style={{display:'block',width:'100%',height:'auto',border:'1px solid #ccc'}}/></figure>)}</div>;
}
